import { render, staticRenderFns } from "./Juniors.vue?vue&type=template&id=d31ba4cc"
import script from "./Juniors.vue?vue&type=script&lang=js"
export * from "./Juniors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports